"use strict";

jQuery(document).ready(function ($) {
  var submitClicked = null;
  $('button[type="submit"]').on('click', function (e) {
    submitClicked = $(this).attr('id');
  });
  $('.charity-register__form').on('submit', function (e) {
    e.preventDefault();

    if (submitClicked == 'signup-nopack') {
      submitFormNoPack();
    } else if (submitClicked == 'signup-with-pack') {
      submitFormWithPack();
    } else {
      var nextStage = $(this).attr('data-next');
      $(".charity-register__form--stage-".concat(nextStage - 1)).toggle();
      $(".charity-register__form--stage-".concat(nextStage)).toggle();
    }
  });
  $('#register-welcome-pack').on('change', function () {
    if (this.checked) {
      $('#stage-2-next').css('display', 'inline-block');
      $('#signup-nopack').toggle();
    } else {
      $('#stage-2-next, #signup-nopack').toggle();
    }
  });

  var submitFormNoPack = function submitFormNoPack() {
    var type = 'reg-without-pack';
    var data = $('.charity-register__form--stage-1, .charity-register__form--stage-2').serialize();
    data += '&welcome-pack=false';
    submit(type, data);
  };

  var submitFormWithPack = function submitFormWithPack() {
    var type = 'reg-with-pack';
    var data = $('.charity-register__form--stage-1, .charity-register__form--stage-2, .charity-register__form--stage-3').serialize();
    submit(type, data);
  };

  var submit = function submit(type, data) {
    grecaptcha.ready(function () {
      try {
        grecaptcha.execute('6LcXDn8kAAAAAGd9-w2RLz3jTlr36Fk-jCefLVzZ', {
          action: 'submit'
        }).then(function (token) {
          $.ajax({
            type: 'GET',
            url: ajax.ajax_url,
            data: {
              action: 'submit_reg',
              token: token,
              type: type,
              data: data
            },
            beforeSend: function beforeSend() {
              $('.charity-register__form').css('display', 'none');
              $('.charity-register__loader').css('display', 'inline-block');
            },
            success: function success(response) {
              displayFormResponse(response);
            },
            error: function error(MLHttpRequest, response, errorThrown) {
              console.log(errorThrown);
              displayFormResponse(response);
            }
          });
        });
      } catch (error) {
        console.log(error);
        $('.charity-register__form').css('display', 'none');
        $('.charity-register__response').text('Unable to verify captcha, please try again later.');
      }
    });
  };

  var displayFormResponse = function displayFormResponse(response) {
    $('.charity-register__loader').css('display', 'none');
    var parsedResponse = jQuery.parseJSON(response);
    var message = parsedResponse['message'];
    $('.charity-register__response').html(message);
  };
});